/*
 * This file is part of sepia-themes.
 * Copyright (C) 2024 Data Futures GmbH.
 *
 * sepia-themes is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */

import { loadModuleMetadata as CommunitiesModuleMetadata } from "./communities";

/**
 * Modules metadata
 */
const ModulesMetadata = [CommunitiesModuleMetadata()];

/**
 * Configurations of the sepia custom components for the Invenio Overridable Registry.
 */
export const SepiaComponents = ModulesMetadata.reduce((acc, item) => {
  acc = { ...acc, ...item };
  return acc;
}, {});
